import { render, staticRenderFns } from "./TextBlocksPage.vue?vue&type=template&id=133e96c5&scoped=true"
import script from "./TextBlocksPage.vue?vue&type=script&lang=js"
export * from "./TextBlocksPage.vue?vue&type=script&lang=js"
import style0 from "./TextBlocksPage.vue?vue&type=style&index=0&id=133e96c5&prod&lang=css"
import style1 from "./TextBlocksPage.vue?vue&type=style&index=1&id=133e96c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e96c5",
  null
  
)

export default component.exports